import React from 'react';
import { InputRow } from '../../../helpers/uiComponents/InputRow';

class StepThree extends React.Component {
    render() {
        const data = this.props.data;
        const doFunction = this.props.doFunction;

        return(
            <React.Fragment>
                {(data && data.length > 0) && (
                    <React.Fragment>
                    <h4>3. Select the Email Series that you want to test an event for</h4>
                    <InputRow label="Email Series Name*" type="select" options={data} id="widgetId" onChange={doFunction} />
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }
}
export default StepThree;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/TestSteps/StepThree.js